"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var squareRegex = /^(\$?)([A-Z]+)(\$?)([0-9]+)$/;
var letterRegex = /^(\$?)([A-Z]+)$/;
var numRegex = /^(\$?)([0-9]+)$/;
function offsetSquare(square, offset) {
  return {
    col: ordToLetter(letterToOrd(square.col) + offset.col),
    row: square.row + offset.row
  };
}
function getSquare(_ref, offset) {
  var row = _ref.row,
    col = _ref.col;
  if (offset) {
    return getSquare(offsetSquare({
      row: row,
      col: col
    }, offset));
  }
  return col + row;
}
function getPosition(square) {
  if (squareRegex.test(square)) {
    var a = squareRegex.exec(square);
    var row = parseInt(a[4], 10);
    var col = a[2];
    return {
      row: row,
      col: col,
      fixedRow: a[3] === "$",
      fixedCol: a[1] === "$"
    };
  }
  if (letterRegex.test(square)) {
    var _a = letterRegex.exec(square);
    var _col = _a[2];
    return {
      col: _col,
      fixedCol: _a[1] === "$"
    };
  }
  if (numRegex.test(square)) {
    var _a2 = numRegex.exec(square);
    var _row = parseInt(_a2[2], 10);
    return {
      row: _row,
      fixedRow: _a2[1] === "$"
    };
  }
  return {
    invalid: true
  };
}
function parseRangeWidthHeight(ref) {
  var splitted = ref.split(":");
  var startPosition = getPosition(splitted[0]);
  var endPosition = getPosition(splitted[1]);
  if (startPosition.invalid || endPosition.invalid) {
    return {
      invalid: true
    };
  }
  var height = endPosition.row - startPosition.row + 1;
  var width = endPosition.col ? letterToOrd(endPosition.col) - letterToOrd(startPosition.col) + 1 : null;
  return {
    col: startPosition.col,
    row: startPosition.row,
    height: height,
    width: width,
    fixed: [startPosition.fixedCol, startPosition.fixedRow, endPosition.fixedCol, endPosition.fixedRow]
  };
}
function parseRange(ref) {
  var splitted = ref.split(":");
  var startPosition = getPosition(splitted[0]);
  var endPosition = getPosition(splitted[1]);
  return [startPosition, endPosition];
}
function d(bool) {
  return bool ? "$" : "";
}
function parseSheetRange(range) {
  var splitted = range.split("!");
  var sheet = splitted[0].replace(/'/g, "");
  splitted = splitted[1].replace(/\$/g, "").split(":");
  var result = {
    sheet: sheet
  };
  result.start = getPosition(splitted[0]);
  if (splitted.length > 1) {
    result.end = getPosition(splitted[1]);
  }
  return result;
}
function stringifySheetRange(range) {
  var suffix = "";
  if (range.end) {
    suffix += ":" + getSquare(range.end);
  }
  return range.sheet + "!" + getSquare(range.start) + suffix;
}
function stringifyRangeWidthHeight(range) {
  var fixed = range.fixed;
  fixed = fixed || [false, false, false, false];
  return "".concat(d(fixed[0])).concat(range.col || "").concat(d(fixed[1])).concat(range.row || "", ":").concat(d(fixed[2])).concat(range.col ? ordToLetter(letterToOrd(range.col) + range.width - 1) : "").concat(d(fixed[3])).concat(range.row ? range.row + range.height - 1 : "");
}
function stringifyRange(range) {
  var _range = _slicedToArray(range, 2),
    startPosition = _range[0],
    endPosition = _range[1];
  return getSquare(startPosition) + ":" + getSquare(endPosition);
}
function ordToLetter(ord) {
  if (!ord) {
    return "";
  }
  ord -= 1;
  var letters = "";
  do {
    var letterInt = ord % 26 + 1;
    letters = String.fromCharCode(letterInt + 64) + letters;
    ord = (ord - letterInt) / 26;
  } while (ord > 0);
  return letters;
}
function letterToOrd(letter) {
  var length = letter.length;
  var sum = 0;
  while (length > 0) {
    sum *= 26;
    sum += letter.charCodeAt(0) - 64;
    letter = letter.slice(1);
    length--;
  }
  return sum;
}
function getMaxTL(a, b) {
  var col;
  var row;
  if (a.col == null) {
    col = b.col;
  } else if (b.col == null) {
    col = a.col;
  } else {
    col = ordToLetter(Math.min(letterToOrd(a.col), letterToOrd(b.col)));
  }
  if (a.row == null) {
    row = b.row;
  } else if (b.row == null) {
    row = a.row;
  } else {
    row = Math.min(a.row, b.row);
  }
  return {
    row: row,
    col: col
  };
}
function getMaxBR(a, b) {
  var col;
  var row;
  if (a.col == null) {
    col = b.col;
  } else if (b.col == null) {
    col = a.col;
  } else {
    col = ordToLetter(Math.max(letterToOrd(a.col), letterToOrd(b.col)));
  }
  if (a.row == null) {
    row = b.row;
  } else if (b.row == null) {
    row = a.row;
  } else {
    row = Math.max(a.row, b.row);
  }
  return {
    row: row,
    col: col
  };
}
module.exports = {
  ordToLetter: ordToLetter,
  letterToOrd: letterToOrd,
  getSquare: getSquare,
  getPosition: getPosition,
  parseRange: parseRange,
  parseRangeWidthHeight: parseRangeWidthHeight,
  stringifyRange: stringifyRange,
  stringifyRangeWidthHeight: stringifyRangeWidthHeight,
  parseSheetRange: parseSheetRange,
  stringifySheetRange: stringifySheetRange,
  getMaxTL: getMaxTL,
  getMaxBR: getMaxBR,
  offsetSquare: offsetSquare
};